import React from "react";
import FixedDecimalTextField from "./FixedDecimalTextField";

const NUMBER = ({ params, item, handleRowUpdate, rowError }) => {
  const component = item?.inputType?.component || item?.component;
  const fieldName = item?.sColumnID || item?.inputtable?.sColumnID;
  const fieldId =
    params?.row?._fieldIds?.[fieldName] ||
    component?.sName ||
    fieldName;

  return (
    <FixedDecimalTextField
      component={component}
      value={params?.row?.[fieldName] ?? component?.sDefaultValue ?? "0"}
      onValueChange={value => {
        handleRowUpdate?.({
          fieldName,
          value,
          rowId: params?.row?.id,
        });
      }}
      placeholder={component?.sPlaceHolder}
      id={`${fieldId}-${params?.row?.id}`}
      error={!!rowError}
      helperText={rowError || ""}
    />
  );
};

export default NUMBER;
